import { getErrorMessage } from './errorCodes';

/**
 * API 에러 응답을 분기 처리하는 공통 핸들러
 * @param {object} response - 서버 응답 객체
 * @param {function} showModal - 안내 메시지 모달 표시 함수 (필수)
 * @param {function} handleMasking - 마스킹 처리 함수 (2100대만 필요시)
 */
export function handleApiError(response, { showModal, handleMasking }) {
  const code = response?.error?.code || response?.code;

  // 서버가 제공한 메시지를 우선 사용, 없으면 매핑/기본값으로 폴백
  const resolveMessage = (c) => {
    const mapped = typeof c !== 'undefined' && c !== null
      ? getErrorMessage(String(typeof c === 'string' ? parseInt(c, 10) : c))
      : null;
    return (
      response?.error?.message ??
      response?.message ??
      mapped ??
      '알 수 없는 오류가 발생했습니다.'
    );
  };

  if (!code) {
    showModal(resolveMessage(code));
    return;
  }

  const codeNum = typeof code === 'string' ? parseInt(code, 10) : code;

  if (codeNum >= 2100 && codeNum < 2200 && typeof handleMasking === 'function') {
    // 마스킹 관련 에러만 별도 분기
    handleMasking(response);
    return;
  }

  // 서버 메시지 > 매핑 > 기본값 순으로 표시
  showModal(resolveMessage(codeNum));
} 